<ng-container *ngIf="qrcode">
  <qrcode [qrdata]="qrcode" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
</ng-container>
